import { createAuthoringComparisonNormalizers } from "./authoring-comparison-normalizers"

let browserNormalizers = null

function getBrowserContainer() {
    if (typeof document === "undefined") return null
    return document.createElement("div")
}

/**
 * @returns {ReturnType<typeof createAuthoringComparisonNormalizers>}
 */
export function createBrowserAuthoringNormalizers() {
    if (typeof document === "undefined") {
        return createAuthoringComparisonNormalizers(() => null)
    }

    const container = getBrowserContainer()
    return createAuthoringComparisonNormalizers(() => container)
}

/**
 * Shared browser normalizers for main-thread fallback and legacy imports.
 * @returns {ReturnType<typeof createAuthoringComparisonNormalizers>}
 */
export function getBrowserAuthoringNormalizers() {
    if (!browserNormalizers) {
        browserNormalizers = createBrowserAuthoringNormalizers()
    }
    return browserNormalizers
}
